import { useAuth } from "./useAuth";

export function useCommunityRole() {
  const { hasRole, isPtaAdmin } = useAuth();
  
  const isCommunityRole = hasRole('community');
  const isSiteAdmin = hasRole('site_admin');
  const hasCommunityAccess = isCommunityRole || isPtaAdmin || isSiteAdmin;

  return {
    isCommunityRole,
    hasCommunityAccess
  };
}
